function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var getTaskDetailWrapStyle = function getTaskDetailWrapStyle(prefixCls, token) {
  return _defineProperty({}, ".".concat(prefixCls), _defineProperty({
    display: 'flex',
    flex: 1,
    minWidth: 0,
    minHeight: 0,
    flexDirection: 'column'
  }, ".empty-task-detail", {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%'
  }));
};
export var getTaskDetailStyle = function getTaskDetailStyle(prefixCls, token) {
  return _defineProperty({}, ".".concat(prefixCls), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    display: 'flex',
    flex: 1,
    minWidth: 0,
    minHeight: 0,
    flexDirection: 'column',
    position: 'relative'
  }, ".empty-task-detail", {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%'
  }), ".anchor-col", _defineProperty({
    position: 'sticky',
    top: '0px',
    display: 'flex',
    width: '120px',
    zIndex: 999
  }, ".anchor-line", {
    width: '1px',
    backgroundColor: 'rgba(15, 15, 15, 0.1)',
    marginRight: '0px'
  })), ".ant-anchor-wrapper:not(.ant-anchor-wrapper-horizontal) .ant-anchor .ant-anchor-ink", {
    width: '8px !important',
    // 圆环的直径
    height: '8px !important',
    // 圆环的直径
    backgroundColor: 'transparent !important',
    // 背景色透明
    border: '2px solid #4C65ED !important',
    // 圆环的颜色和宽度
    borderRadius: '50% !important' // 使其成为圆形
  }), ".ant-anchor-wrapper:not(.ant-anchor-wrapper-horizontal) .ant-anchor::before", {
    border: '2px solid transparent'
  }), ".right-content", _defineProperty(_defineProperty(_defineProperty({
    position: 'relative',
    flex: 1,
    minWidth: 0,
    minHeight: 0,
    overflow: 'auto',
    display: 'flex',
    justifyContent: 'space-between',
    containerType: 'inline-size',
    '.flowTaskDetail': {
      flex: 1,
      minWidth: 0
    }
  }, ".taskDetailHeader", {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    top: '0px',
    backgroundColor: '#FFFFFF',
    padding: '16px 16px 0'
  }), '.taskDetailForm', {
    padding: '0 16px'
  }), '.taskSection', {
    backgroundColor: '#F6F6F9',
    padding: '12px 0 12px 12px',
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '24px'
  })), '@container (max-width: 700px)', _defineProperty({}, ".anchor-col", {
    // 解决锚点ink渲染位置出错的问题，这里没有用display: 'none'
    width: '0px',
    opacity: 0
  })), ".operation-bar", _defineProperty(_defineProperty({
    // position: 'sticky',
    // bottom: 0,
    // width: '100%',
    // zIndex: 10,
    backgroundColor: '#FFFFFF',
    display: 'flex',
    flexDirection: 'column'
  }, ".divider", {
    margin: '0px'
  }), ".button-group", {
    backgroundColor: '#FFFFFF',
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '14px 24px 14px 0',
    gap: 12
  })));
};